/**
 * CODE_COMMENTS_31
 */
export const COLLAR_ORDER_FULL_DETAILS_DELIVERY_ADDRESS = 'Delivery Address'
export const COLLAR_ORDER_FULL_DETAILS_LABEL_COMMENTS = 'Your Order Comments'
export const COLLAR_ORDER_FULL_DETAILS_LABEL_DELIVERY_DATE = 'Delivery Date'
